import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useThemeUI } from 'theme-ui';
import { TruCaret } from '@uswitch/spark-icons/tru';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export var DropDown = function DropDown(_ref) {
  var _accordionTheme$base4, _accordionTheme$base5;

  var title = _ref.title,
      _ref$isInitiallyOpen = _ref.isInitiallyOpen,
      isInitiallyOpen = _ref$isInitiallyOpen === void 0 ? false : _ref$isInitiallyOpen,
      children = _ref.children,
      className = _ref.className,
      _ref$isCard = _ref.isCard,
      isCard = _ref$isCard === void 0 ? false : _ref$isCard,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'base' : _ref$variant;

  var _useThemeUI = useThemeUI(),
      _useThemeUI$theme = _useThemeUI.theme,
      _useThemeUI$theme$com = _useThemeUI$theme.compounds.accordion,
      accordionTheme = _useThemeUI$theme$com === void 0 ? {} : _useThemeUI$theme$com,
      _useThemeUI$theme$col = _useThemeUI$theme.colors,
      colors = _useThemeUI$theme$col === void 0 ? {} : _useThemeUI$theme$col;

  var _React$useState = React.useState(isInitiallyOpen),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var getIconColor = function getIconColor(isOpen) {
    if (variant === 'eligibility-criteria-redesign') {
      return colors['button-secondary'];
    } else {
      var _accordionTheme$base, _accordionTheme$base$, _accordionTheme$base$2, _accordionTheme$base2, _accordionTheme$base3;

      return isOpen ? colors[accordionTheme === null || accordionTheme === void 0 ? void 0 : (_accordionTheme$base = accordionTheme.base) === null || _accordionTheme$base === void 0 ? void 0 : (_accordionTheme$base$ = _accordionTheme$base.isActive) === null || _accordionTheme$base$ === void 0 ? void 0 : (_accordionTheme$base$2 = _accordionTheme$base$.caret) === null || _accordionTheme$base$2 === void 0 ? void 0 : _accordionTheme$base$2.color] : colors[accordionTheme === null || accordionTheme === void 0 ? void 0 : (_accordionTheme$base2 = accordionTheme.base) === null || _accordionTheme$base2 === void 0 ? void 0 : (_accordionTheme$base3 = _accordionTheme$base2.caret) === null || _accordionTheme$base3 === void 0 ? void 0 : _accordionTheme$base3.color];
    }
  };

  var getVariant = function getVariant(element, isOpen) {
    var baseVariant = variant && variant !== 'base' ? ".variants.".concat(variant) : '.base';
    var elementVariant = element ? ".".concat(element) : '';
    var activeVariant = isOpen ? '.isActive' : '';
    return "compounds.accordion".concat(baseVariant).concat(activeVariant).concat(elementVariant);
  };

  var getCardStyles = function getCardStyles() {
    return isCard ? {
      position: 'absolute',
      bottom: '0',
      mb: '0',
      width: '100%',
      minHeight: isOpen ? '80%' : 'auto',
      boxShadow: isOpen ? '0px -1px 16px rgba(0, 0, 0, 0.15), 0px -159px 36px 4px rgba(255, 255, 255, 0.7)' : 'none'
    } : {};
  };

  return _jsxs("div", {
    sx: _objectSpread({
      variant: getVariant('wrapper', isOpen)
    }, getCardStyles()),
    className: className,
    children: [_jsxs("button", {
      sx: {
        color: 'textColor',
        cursor: 'pointer',
        variant: getVariant('btn', isOpen)
      },
      onClick: function onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(!isOpen);
      },
      children: [_jsx("div", {
        sx: {
          flex: '1',
          textAlign: 'left',
          variant: getVariant('title')
        },
        children: title
      }), isOpen === 'up' ? _jsx(TruCaret, {
        color: getIconColor(isOpen),
        size: 16
      }) : _jsx(TruCaret, {
        color: getIconColor(isOpen),
        size: 16,
        sx: {
          transform: 'rotate(0.5turn)'
        }
      })]
    }), _jsx("div", {
      sx: {
        color: 'textColor',
        overflow: 'hidden',
        height: isOpen ? 'auto' : '0',
        marginBottom: isOpen ? accordionTheme === null || accordionTheme === void 0 ? void 0 : (_accordionTheme$base4 = accordionTheme.base) === null || _accordionTheme$base4 === void 0 ? void 0 : (_accordionTheme$base5 = _accordionTheme$base4.content) === null || _accordionTheme$base5 === void 0 ? void 0 : _accordionTheme$base5.marginBottom : '0',
        '> *:first-of-type': {
          marginTop: 0
        },
        '> *:last-child': {
          marginBottom: 0
        },
        '> p:last-child': {
          marginBottom: 'xs'
        },
        variant: getVariant('content')
      },
      children: children
    })]
  });
};
export default DropDown;
//# sourceMappingURL=dropdown.js.map